import * as types from 'store/modules/hres37u/mutation-types'
import hres37u from 'api/hres37u'
import swal from 'sweetalert'
import hres37uLabels from 'assets/labels/hres37u'
import { hres37uColumns } from 'assets/columns/hres37u'
import configLabel from 'src/../config/label'
import { constLabels } from 'assets/js/constLabels.js'
import * as dashTypes from 'store/modules/dash/mutation-types'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres37uLabels,
    columns: hres37uColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {},
    approve: {},
    indexSelected: []
  },
  getters: {
    [types.GET_HRES37U_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES37U_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES37U_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES37U_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES37U_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES37U_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES37U_DETAIL] (state) {
      return state.detail
    }
  },
  mutations: {
    [types.SET_HRES37U_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES37U_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES37U_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRES37U_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES37U_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES37U_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES37U_DETAIL] (state, data) {
      state.detail = data
    }
  },
  actions: {
    [types.TOGGLE_HRES37U_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES37U_INDEX_DISP, indexDisp)
      commit(types.SET_HRES37U_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES37U_COLUMNS_LABELS] ({ commit }) {
      hres37u.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES37U_COLUMNS, data.labels)
          commit(types.SET_HRES37U_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES37U_INDEX] ({ commit }, searchParams) {
      hres37u.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES37U_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES37U_DETAIL] ({ commit }, detailParams) {
      hres37u.getDetail(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES37U_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES37U_SEND_APPROVE] ({ commit, dispatch }, params) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          let referenceButton = params.referenceButton
          hres37u.postSendApprove(params.approveParams)
          .then((response) => {
            const data = JSON.parse(response.request.response)
            dispatch(types.RECEIVED_HRES37U_INDEX, {})
            dispatch(dashTypes.RECEIVED_HEADER_NOTI_TOTAL, 'P,Y,N,A')
            swal({title: '', text: data.response, html: true, type: 'success'}, function () {
              referenceButton.click()
            })
          })
          .catch((error) => {
            let message = error
            if (error.response) {
              const data = error.response.data
              message = data.response
            }
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres37u/index.js